// extracted by mini-css-extract-plugin
export default {"emptyContainer":"Orders__emptyContainer___2rFtf","loadingMessage":"Orders__loadingMessage___3dsxz","headerRow":"Orders__headerRow___5FT1B","headerCell":"Orders__headerCell___3slcP"};